export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[System]]]').after('[[[Administracja]]]', [
        {
            name: '[[[Wyszukiwanie]]]',
            icon: 'search',
            namespace: 'Ideo.Core.Common.Application.Permissions.Search',
            children: [
                {
                    name: '[[[Lista indeksów]]]',
                    auth: { all: ['SearchPermissions@Access'], any: [] },
                    route: 'search-indices'
                },
                {
                    name: '[[[Podgląd indeksu]]]',
                    auth: { all: ['SearchPermissions@Access'], any: [] },
                    route: 'search-textsearch'
                },
                {
                    name: '[[[Słowa wykluczone]]]',
                    auth: { all: ['StopWordsPermissions@Access'], any: [] },
                    route: 'search-stopwords'
                },
                {
                    name: '[[[Synonimy]]]',
                    auth: { all: ['SynonymsPermissions@Access'], any: [] },
                    route: 'search-synonyms'
                }
            ]
        }
    ]);
};
